/**
 * License in Query String
 */

import { invert, template } from 'lodash';
import { QueryStringFilter, QueryStringParam } from './types';

// tslint:disable-next-line:max-line-length no-invalid-template-strings
const licenseStringTemplate = template('${medium}${sep}${term}${sep}${spot_count}${sep}${contextual_param}${sep}${contextual_param_type}');

const usageSeparator = '|';
const paramSeparator = ';';
const propSeparator = ':';

const shortNames = {
  BroadcastTerritory: 'bt',
  ProducerLocation: 'pl',
  AudienceSize: 'as',
  spot_count: 'c',
  medium: 'm',
  term: 't',
  contextual_param: 'p',
  contextual_param_type: 'pt',
};

function shortname(value: string) {
  return shortNames[value] || value;
}
function fullname(value: string) {
  return invert(shortNames)[value] || value;
}

const getSerializedProp = (license: GQL.ILicenseUsageParamsInput) => (prop: keyof GQL.ILicenseUsageParamsInput) => {
  let value = license[prop];
  if (typeof value === 'object') {
    value = JSON.stringify(value);
  }
  return `${shortname(prop)}${propSeparator}${shortname(value as string)}`;
};

type LicenseQueryStringFilter = QueryStringFilter<GQL.ILicenseUsageParamsInput[]>;

export const LicenseFilter: LicenseQueryStringFilter = {
  serialize: (params) => {
    return btoa(params.map((license) => {
      const propSelector = getSerializedProp(license);
      const licenseString = licenseStringTemplate({
        medium: propSelector('medium'),
        term: propSelector('term'),
        spot_count: propSelector('spot_count'),
        contextual_param: propSelector('contextual_param'),
        contextual_param_type: propSelector('contextual_param_type'),
        sep: paramSeparator,
      });
      return licenseString.replace(',,', ',');
    }).join(usageSeparator));
  },
  unserialize: (query) => {
    if (QueryStringParam.License in query) {
      const decodedString = atob(query[QueryStringParam.License]);

      // If the decoded license string contains the word `medium` in full, it means it's an old license url.
      // In this case, we simply do a JSON.parse to get our valid GQL.ILicenseUsageParamsInput[].
      if (decodedString.indexOf('medium') > -1) {
        return JSON.parse(decodedString);
      }

      const licenses = decodedString.split(usageSeparator);
      const licenseParamsReducer: GQL.ILicenseUsageParamsInput[] = [];
      const paramsReducer: Partial<GQL.ILicenseUsageParamsInput> = {};

      return licenses.reduce((acc, license) => {
        const params = license.split(paramSeparator);
        const usages = params.reduce((accParams, param) => {
          let value: number | number[] | string;
          let [key, stringValue] = param.split(propSeparator);

          key = fullname(key);
          stringValue = fullname(stringValue);

          try {
            value = JSON.parse(stringValue);
          } catch (error) {
            value = stringValue;
          }

          if (value === 'undefined') {
            return accParams;
          }

          return {
            ...accParams,
            [key]: value,
          };
        }, paramsReducer);

        acc.push(usages as GQL.ILicenseUsageParamsInput);

        return acc;
      }, licenseParamsReducer);
    }

    return [];
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/contexts/queryString/license.ts